import { apiSlice } from "../apiSlice";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;

export interface FilterTag {
    tag: string;
    show: boolean;
}

export interface FilterTagGroup {
    allowMultipleSelect: boolean;
    tags: FilterTag[];
}

export interface FilterTagsinterface {
    [category: string]: FilterTagGroup;
}

export interface FilterTagsReqRes {
    restaurantId: string;
    filterTags: FilterTagsinterface;
}


export const filterTagService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        updateFilterTags: builder.mutation<FilterTagsReqRes, FilterTagsReqRes>({
            query: (requestData) => ({
                url: `https://adminhttps-updatefiltertags${API_BASE_DOMAIN}`,
                method: "POST",
                body: requestData,
                responseHandler: (response) => response.text(),
            }),
        }),
        getFilterTags: builder.query<FilterTagsReqRes, string>({
            query: (restaurantId) => ({
                url: `https://userhttps-getrestaurantfiltertags${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
                method: "GET",
                responseHandler: (response) => response.json(),
            }),
        }),
    })
});
export const { useUpdateFilterTagsMutation, useGetFilterTagsQuery, useLazyGetFilterTagsQuery } = filterTagService;